import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { degreeTitles } from './const';
import { default as countryList } from './countryList.json';
import './style.scss';

export default function Education({ education }) {
    const {
        degree_title,
        degree,
        school,
        to_year,
        country_code
    } = education;

    const country = countryList.find((country) => country.code === country_code.toLowerCase()).value;

    return (
        <li>
            <p>{degreeTitles[degree_title]} - {degree}</p>
            <p>
                {school}, {country}, <I18n k="user_page_perseus.seller_profile.graduated"/> {to_year}
            </p>
        </li>
    );
}

Education.propTypes = {
    education: PropTypes.shape({
        degree_title: PropTypes.number,
        degree: PropTypes.string,
        school: PropTypes.string,
        to_year: PropTypes.number
    })
};

Education.defaultProps = {
    education: {
        degree_title: 0,
        degree: '',
        school: '',
        to_year: 0
    }
};
